import { styled } from 'linaria/react';

export type DelayedContentProps = {
  deferTimeout?: number;
};

export const DelayedContent = styled.span<DelayedContentProps>`
  display: contents;

  animation-name: DelayedContent;
  animation-duration: 0s;
  animation-delay: ${({ deferTimeout = 300 }) => `${deferTimeout}ms`};
  animation-fill-mode: both;

  @keyframes DelayedContent {
    from {
      visibility: hidden;
    }
    to {
      visibility: visible;
    }
  }
`;
